/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmptyResponse } from '../models/empty-response';
import { userRankActions } from '../fn/user-rank/user-rank-actions';
import { UserRankActions$Params } from '../fn/user-rank/user-rank-actions';
import { userRankConfiguration } from '../fn/user-rank/user-rank-configuration';
import { UserRankConfiguration } from '../models/user-rank-configuration';
import { UserRankConfiguration$Params } from '../fn/user-rank/user-rank-configuration';
import { userRankSaveAction } from '../fn/user-rank/user-rank-save-action';
import { UserRankSaveAction$Params } from '../fn/user-rank/user-rank-save-action';
import { UserRankScoreWithActions } from '../models/user-rank-score-with-actions';

@Injectable({ providedIn: 'root' })
export class UserRankService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userRankSaveAction()` */
  static readonly UserRankSaveActionPath = '/user-rank';

  /**
   * Save multiple user rank actions and increase user rank score.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRankSaveAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRankSaveAction$Response(params: UserRankSaveAction$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
    return userRankSaveAction(this.http, this.rootUrl, params, context);
  }

  /**
   * Save multiple user rank actions and increase user rank score.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRankSaveAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRankSaveAction(params: UserRankSaveAction$Params, context?: HttpContext): Observable<EmptyResponse> {
    return this.userRankSaveAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmptyResponse>): EmptyResponse => r.body)
    );
  }

  /** Path part for operation `userRankConfiguration()` */
  static readonly UserRankConfigurationPath = '/user-rank/configuration';

  /**
   * Get user rank configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRankConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRankConfiguration$Response(params?: UserRankConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRankConfiguration>> {
    return userRankConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user rank configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRankConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRankConfiguration(params?: UserRankConfiguration$Params, context?: HttpContext): Observable<UserRankConfiguration> {
    return this.userRankConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserRankConfiguration>): UserRankConfiguration => r.body)
    );
  }

  /** Path part for operation `userRankActions()` */
  static readonly UserRankActionsPath = '/user-rank/{userId}';

  /**
   * Get user rank actions for single user (current day).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRankActions()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRankActions$Response(params: UserRankActions$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRankScoreWithActions>> {
    return userRankActions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get user rank actions for single user (current day).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRankActions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRankActions(params: UserRankActions$Params, context?: HttpContext): Observable<UserRankScoreWithActions> {
    return this.userRankActions$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserRankScoreWithActions>): UserRankScoreWithActions => r.body)
    );
  }

}
